import { render, staticRenderFns } from "./PobDetailsModel.vue?vue&type=template&id=16e3d35d&scoped=true&"
import script from "./PobDetailsModel.vue?vue&type=script&lang=js&"
export * from "./PobDetailsModel.vue?vue&type=script&lang=js&"
import style0 from "./PobDetailsModel.vue?vue&type=style&index=0&id=16e3d35d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e3d35d",
  null
  
)

export default component.exports